<template>
    <b-container>
        <b-row>
            <b-col>
                <b-card no-body>
                    <b-tabs pills card vertical v-model="currentTabIndex">
                        <b-tab :title="$t('project.settings.general.tabGeneral')" active>
                            <tab-general></tab-general>
                        </b-tab>
                        <b-tab :title="$t('project.settings.general.tabParticipants')">
                            <tab-members></tab-members>
                        </b-tab>
                        <b-tab :title="$t('project.settings.general.tabEmails')">
                            <tab-emails></tab-emails>
                        </b-tab>
                        <b-tab :title="$t('project.settings.general.tabAdvanced')" v-show="isProjectOwner">
                            <tab-advanced></tab-advanced>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import TabGeneral from './TabGeneral';
import TabMembers from './TabMembers';
import TabEmails from './TabEmails';
import TabAdvanced from './TabAdvanced';

export default {
    name: 'project-settings',

    components: {  
        TabGeneral, TabMembers, TabEmails, TabAdvanced
    },

    data() {
        return {
            currentTabIndex: 0
        }
    },

    mounted() {
        this.currentTabIndex = 0;
        let projectId = this.$route.params.projectId;

        this.$store.dispatch('system/loadInputLimits');
        this.$store.dispatch('projects/getProjectUploadStatus', { projectId });
        this.$store.dispatch('projects/loadCollaboratorsByProject', { projectId });
    },

    computed: {
        ...mapGetters({
            isProjectOwner: 'projects/isProjectOwner'
        })
    }
}
</script>

<style>
</style>
